import { Suspense } from "react";

// project-imports
import Loader from "./Loader";
import PageLoader from "./PageLoader";

// ==============================|| LOADABLE - LAZY LOADING ||============================== //
//
// Renders a thin top progress bar plus a centred page loader so route changes
// show a gentle loader in the content area instead of a blank white screen.

const Loadable = (Component) => (props) =>
  (
    <Suspense
      fallback={
        <>
          <Loader />
          <PageLoader />
        </>
      }
    >
      <Component {...props} />
    </Suspense>
  );

export default Loadable;
